<template>
    <section class="credit-contact-list-wrapper">
        <div class="row">
            <div class="col-12 mb-1">
                <button
                    v-if="this.$route.params && this.$route.params.client"
                    class="btn btn-success float-right"
                    @click="creditContactStore.type = 2"   
                >
                    Create
                </button>
                <router-link
                    v-else
                    :to="{ name: 'credit-contact-create' }"
                    class="btn btn-success float-right"
                >
                    Create
                </router-link>
            </div>
        </div>
        <div class="card">
            <vue-good-table
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:per-page-change="onPerPageChange"
                v-on:selected-rows-change="creditContactSelectionChanged"
                v-on:search="onSearch"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: true,
                }"
                :search-options="{
                    enabled: true
                }"
                :select-options="{
                    enabled: true,
                    disableSelectInfo: true,
                    selectOnCheckboxOnly: true
                }"
            >
                <template #table-row="props">
                    <span v-if="props.column.field === 'action'">
                        <div class="d-flex align-items-center col-actions">
                            <button
                                v-if="this.$route.params && this.$route.params.client"
                                class="mr-1 text-primary"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="View Credit Contact Detail"
                                @click="creditContactStore.type = 3; creditContactStore.credit_contact_id = props.row.id"
                            >
                                <vue-feather type="eye" size="14"></vue-feather>
                            </button>
                            <router-link
                                v-else
                                :to="{ name: 'credit-contact-preview', params: { credit_contact: props.row.id } }"
                                v-slot="{ href, route, navigate }"
                            >
                                <a
                                    class="mr-1 text-primary"
                                    :href="href"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="View Credit Contact Detail"
                                >
                                    <vue-feather type="eye" size="14"></vue-feather>
                                </a>
                            </router-link>
                            <button
                                v-if="this.$route.params && this.$route.params.client"
                                class="mr-1 text-primary"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Edit Credit Contact"
                                @click="creditContactStore.type = 4; creditContactStore.credit_contact_id = props.row.id"
                            >
                                <vue-feather type="edit" size="14"></vue-feather>
                            </button>
                            <router-link
                                v-else
                                :to="{ name: 'credit-contact-edit', params: { credit_contact: props.row.id } }"
                                v-slot="{ href, route, navigate }"
                            >
                                <a
                                    class="mr-1 text-primary"
                                    :href="href"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Edit Credit Contact"
                                >
                                    <vue-feather type="edit" size="14"></vue-feather>
                                </a>
                            </router-link>
                            <a
                                class="mr-1 text-primary"
                                @click="deleteCreditContact(props.row.id)"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Delete Credit Contact"
                            >
                                <vue-feather type="trash" size="14"></vue-feather>
                            </a>
                        </div>
                    </span>
                </template>
            </vue-good-table>
        </div>
    </section>
</template>

<script>
    import { VueGoodTable } from 'vue-good-table-next';
    import { useCreditContactStore } from '../../stores/CreditContactStore.js'
    export default {
        mounted() {
            this.getCreditContacts();
        },
        components: {
            VueGoodTable
        },
        setup() {
            return {
                creditContactStore: useCreditContactStore()
            }
        },
        data()
        {
            return {
                currentPage: 1,
                currentPerPage: 10,
                totalRecords: 0,
                columns: [
                    {
                        label: 'Creditor Name',
                        field: 'creditor_name',
                    },
                    {
                        label: 'Address',
                        field: 'address',
                    },
                    {
                        label: 'Address Line',
                        field: 'address_line',
                    },
                    {
                        label: 'City',
                        field: 'city'
                    },
                    {
                        label: 'state',
                        field: 'state'
                    },
                    {
                        label: 'Zipcode',
                        field: 'zipcode'
                    },
                    {
                        label: 'Phone',
                        field: 'phone'
                    },
                    {
                        label: 'Fax Number',
                        field: 'fax_number'
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        width: '140px',
                    }
                ],
                rows: [],
                searchTerm: '',
            }
        },
        methods:{
            onPageChange(params) {
                this.currentPage = params.currentPage;
                this.getCreditContacts();
            },
            onPerPageChange(params) {
                this.currentPerPage = params.currentPerPage;
                this.currentPage = 1;
                this.getCreditContacts();
            },
            onSearch(params){
                this.searchTerm = params.searchTerm;
                this.getCreditContacts();
            },
            getCreditContacts() {
                let params = {};
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                }
                const route = this.$router.resolve(
                    {
                        name: 'credit-contact-index',
                        params: params
                    }
                );
                let $this = this;
                axios.get(
                    route.href,
                    {
                        params: {
                            currentPage: $this.currentPage,
                            currentPerPage: $this.currentPerPage,
                            searchTerm: $this.searchTerm
                        }
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.rows = response.data.data.rows
                    $this.totalRecords = response.data.data.totalRecords
                    return;
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            creditContactSelectionChanged(params) {
            },
            deleteCreditContact(creditContactID) {
                let $this = this,
                route = $this.$router.resolve(
                    {
                        name: 'credit-contact-delete',
                        params: { credit_contact: creditContactID }
                    }
                );
                Swal.fire({
                    title: 'Are you sure you want to delete Credit Contact?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.delete(route.href)
                        .then(function(response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.currentPage = 1;
                            $this.getCreditContacts();
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.response_msg, 'Error!');
                        });
                    }
                });
            }
        },
    }
</script>
